import { AccountType }   from '../api'
import { isInMentoring } from './permissions'

export default (accountType: AccountType) => {
  const isMentoring = isInMentoring(accountType)

  return isMentoring
    ? AccountType.Mentor
    : AccountType.Coach
}



// WEBPACK FOOTER //
// ./src/project-utils/get-teacher.ts